import React from 'react';
import { CheckboxChangeEvent } from 'antd/es/checkbox';
import { Checkbox } from 'antd';

import { CommonTnc2 } from '../CommonTncLI2';

export const AgreementCheckboxLI2 = (props: { onChange: (e: CheckboxChangeEvent) => void }) => {
  return (
    <Checkbox onChange={props.onChange} style={{ fontSize: '17px' }}>
      <CommonTnc2 />
    </Checkbox>
  );
};
